export const tec_aux_saude_bucal = {
  nome: 'Téc. Aux de Saúde Bucal',
  id_perfil: 14,
  dashboard: [
    {
      link: '/vinculo-acompanhamento',
      titulo: 'Vínculo e Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'GestaoCadastros',
      key: 'vinculo_acompanhamento',
      featured: true,
    },
    // {
    //   link: '/indicadores-esb',
    //   titulo: 'Indicadores eSB',
    //   icone: false,
    //   imagem: '',
    //   svg: 'IndicadoresEsb',
    //   key: 'indicadores_esb',
    // },
  ],
  administracao: [],
  gestao_cadastros: [],
  visitas_domiciliares: [],
  imunizacao: [],
  vacina_idade_certa: [],
  divergencia_vacinas: [],
  indicadores_aps: [
    {
      link: '/primeira-consulta-programada',
      titulo: '1ª Consulta programada',
      icone: false,
      imagem: '',
      svg: 'PrimeiraConsultaProgramada',
      key: 'primeira_consulta_programada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/tratamentos-concluidos',
      titulo: 'Tratamentos concluídos',
      icone: false,
      imagem: '',
      svg: 'TratamentosConcluidos',
      key: 'tratamentos_concluidos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/exodontias',
      titulo: 'Exodontias',
      icone: false,
      imagem: '',
      svg: 'Exodontias',
      key: 'exodontias',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/escovacao-supervisionada',
      titulo: 'Escovação supervisionada',
      icone: false,
      imagem: '',
      svg: 'EscovacaoSupervisionada',
      key: 'escovacao_supervisionada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/proporcao-procedimentos-preventivos',
      titulo: 'Procedimentos preventivos',
      icone: false,
      imagem: '',
      svg: 'Prevencao',
      key: 'proporcao_procedimentos_preventivos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/tratamentos-restauradores-art',
      titulo: 'Tratamento restaurador',
      icone: false,
      imagem: '',
      svg: 'TratamentosRestauradoresArt',
      key: 'tratamentos_restauradores_art',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/cuidado-compartilhado',
      titulo: 'Cuidado compartilhado',
      icone: 'icofont-duotone icofont-field-group',
      key: 'cuidado_compartilhado',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/acoes-interprofissionais',
      titulo: 'Ações interprofissionais',
      icone: 'icofont-duotone icofont-field-group',
      key: 'acoes_interprofissionais',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/comunicacao-emulti-e-equipes',
      titulo: 'Comunicação',
      icone: 'icofont-ui-chat',
      key: 'comunicacao_emulti_equipes',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/resolutividade-cuidado-emulti',
      titulo: 'Resolutividade',
      icone: 'icofont-duotone icofont-field-group',
      key: 'resolutividade_cuidado_emulti',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
  ],
  pre_natal: [],
  doencas_cronicas: [],
  desempenho_por_equipe: [],
  saude_crianca: [],
  indicadores_esb: [
    {
      link: '/indicadores-esb/estrategicos',
      titulo: 'Estratégicos',
      icone: false,
      imagem: '',
      svg: 'Estrategicos',
      key: 'indicadores_esb_estrategicos',
    },
    {
      link: '/indicadores-esb/ampliados',
      titulo: 'Ampliados',
      icone: false,
      imagem: '',
      svg: 'Ampliados',
      key: 'indicadores_esb_ampliados',
    },
  ],
  indicadores_esb_estrategicos: [
    {
      link: '/indicadores-esb/estrategicos/gestantes',
      titulo: 'Gestantes',
      icone: false,
      imagem: '',
      svg: 'Gestantes',
      key: 'estrategicos_gestantes',
    },
    {
      link: '/indicadores-esb/estrategicos/criancas',
      titulo: 'Crianças',
      icone: false,
      imagem: '',
      svg: 'Criancas',
      key: 'estrategicos_criancas',
    },
    {
      link: '/indicadores-esb/estrategicos/atendimentos-na-esb',
      titulo: 'Atendimentos na eSB',
      icone: false,
      imagem: '',
      svg: 'AtendimentosNaEsb',
      key: 'atendimentos_na_esb',
    },
  ],
  indicadores_esb_ampliados: [
    {
      link: '/indicadores-esb/ampliados/prevencao',
      titulo: 'Prevenção',
      icone: false,
      imagem: '',
      svg: 'Prevencao',
      key: 'prevencao',
    },
    {
      link: '/indicadores-esb/ampliados/atendimentos-domiciliares',
      titulo: 'Atendimentos domiciliares',
      icone: false,
      imagem: '',
      svg: 'AtendimentosDomiciliares',
      key: 'ampliados_atendimentos_domiciliares',
    },
    {
      link: '/indicadores-esb/ampliados/agendamentos-72h',
      titulo: 'Agendamentos 72h',
      icone: false,
      imagem: '',
      svg: 'Agendamentos72h',
      key: 'agendamentos_72h',
    },
    {
      link: '/indicadores-esb/ampliados/satisfacao-do-cidadao',
      titulo: 'Satisfação do cidadão',
      icone: false,
      imagem: '',
      svg: 'SatisfacaoDoCidadao',
      key: 'satisfacao_do_cidadao',
    },
  ],
  producao: [],
  vinculo_acompanhamento: [
    {
      link: '/diagnostico-situacional',
      titulo: 'Diagnóstico Situacional',
      icone: false,
      imagem: '',
      svg: 'EnvioApp',
      key: 'diagnostico_situacional',
    },
    {
      link: '/cadastros-individuais/profissional',
      titulo: 'Cadastros cidadãos',
      icone: false,
      imagem: '',
      svg: 'CadastrosCidadaos',
      key: 'cadastros_cidadaos',
    },
    {
      link: '/acompanhamento/profissional',
      titulo: 'Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'acompanhamento',
    },
  ],
  bpa_e_ras: [],
}
